import React from 'react';
import PropTypes from 'prop-types';
import { Col, Container } from 'react-bootstrap';
import { compose } from 'utils/react';
import { Row, Section } from 'components';
import ImageWithBanner from 'components/sections/ContactFacility/ImageWithBanner';
import globalClasses from 'theme/facility-globals.scss';
import { BUILDER } from 'shared/abilities';
import { section, stylesModal } from '../decorators';
import style from './FacilityContactHours.scss';

const FacilityContactHours = ({ children, sectionStyle = {} }) => {
  const [
    image,
    content,
    info,
    button,
    hours,
    Carousel,
  ] = React.Children.toArray(children);

  return (
    <Section
      className={globalClasses.section}
      Carousel={Carousel}
      {...sectionStyle}
    >
      <Row verticalAlign="md">
        <Col sm={12} md={8}>
          <Container fluid>
            <Row>
              <Col xs={12} sm={6} className={style.imageContainer}>
                <ImageWithBanner className={style.bannerContainer}>
                  {image}
                  {content}
                </ImageWithBanner>
              </Col>
              <Col xs={12} sm={6} smOffset={6} className={style.contactInfo}>
                {info}
                <div className={style.contactButton}>{button}</div>
              </Col>
            </Row>
          </Container>
        </Col>
        <Col sm={12} md={4} className={style.hours}>
          {hours}
        </Col>
      </Row>
    </Section>
  );
};
FacilityContactHours.propTypes = {
  children: PropTypes.node.isRequired,
  sectionStyle: PropTypes.object,
};

const component = compose(
  stylesModal(),
  section(
    {
      name: 'Facility Info: Hours',
      category: 'Facility',
      defaultPayload: { sectionStyle: { backgroundColor: '#f8f8f8' } },
    },
    {
      subsections: [
        { accepts: ['FacilityImageSlideShow', 'StockIcons'] },
        { accepts: ['ContentBox'] },
        { accepts: ['FacilityInformation'] },
        { accepts: ['Button, HeaderText'] },
        { accepts: ['Hours, HeaderText'] },
        { accepts: ['Carousel'] },
      ],
      defaults: [
        ['FacilityImageSlideShow'],
        ['ContentBox', {
          rawContentState: {
            blocks: [
              {
                key: 'db2mm',
                text: 'Monthly Specials',
                type: 'unstyled',
                depth: 0,
                inlineStyleRanges: [],
                entityRanges: [],
              },
            ],
            entityMap: {},
          },
        }],
        ['FacilityInformation'],
        ['Button', { text: 'Contact Us', href: '/contact-us' }],
        ['Hours'],
        'Carousel',
      ],
      menu: { items: ['edit', 'delete'] },
    },
  ),
)(FacilityContactHours);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
